import type {
  Middleware,
  ResponseContext,
} from "@freightsimple/generated-dashboard-openapi-client/runtime";

type UnauthorizedListener = () => void;

const listeners = new Set<UnauthorizedListener>();

/** Calls the listener whenever a request that carried a session token comes
 *  back 401. Returns the unsubscribe function. */
export function onUnauthorizedResponse(
  listener: UnauthorizedListener,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

// Screens don't handle a 401 themselves, so this reports it to
// useSessionExpiry. It only reports: the backend also answers 401 when a live
// session asks for another company's shipment, so deciding whether the
// session is really over is the listener's job.
export function unauthorizedResponseMiddleware(): Middleware {
  return {
    post: async (context: ResponseContext): Promise<void> => {
      if (context.response.status !== 401) {
        return;
      }
      const authorization = new Headers(context.init.headers).get(
        "authorization",
      );
      if (!authorization?.startsWith("Bearer ")) {
        return;
      }
      listeners.forEach((listener) => listener());
    },
  };
}
